export default __webpack_public_path__ + "static/media/SkillOnNet.8e8ce5fe.png";